var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window-item",class:{even: _vm.index % 2},style:({ backgroundColor: _vm.$store.infoscreenData.infoboardBackgroundColor })},[_c('div',{ref:"windowNumber",staticClass:"window-id",style:({
      color: _vm.$store.infoscreenData.infoboardTicketNumberColor,
      fontSize: _vm.windowNumberFontSize + 'vw',
      fontFamily: ((_vm.$store.infoscreenData.fontBoldFamily) + ", " + (_vm.$store.fontFamilyDefault) + ", sans-serif")
    })},[_vm._v(" "+_vm._s(_vm.orderNumber || _vm.ticketNumber)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }